import api from '../axios';
import type {
  propsRequestLoginBody,
  propsRequestRegisterBody,
  propsResponseLogin,
  propsResponseRefresh,
  propsResponseRegister,
  propsResponseVerifyPin,
} from '../interfaces';

export function login(body: propsRequestLoginBody): Promise<propsResponseLogin> {
  return api.post('/v1/auth/login', body);
}

export function register(body: propsRequestRegisterBody): Promise<propsResponseRegister> {
  return api.post('/v1/auth/register', body);
}

export function logout(refreshToken: string) {
  return api.post('/v1/auth/logout', { refreshToken });
}

export function logoutAll() {
  return api.post('/v1/auth/logout-all');
}

export function verifyEmail(token: string) {
  return api.post('/v1/auth/verify-email', { token });
}

export function refreshSession(refreshToken: string): Promise<propsResponseRefresh> {
  return api.post('/v1/auth/refresh', { refreshToken });
}

export function resendVerification() {
  return api.post('/v1/auth/resend-verification');
}

export function passwordResetRequest(email: string) {
  return api.post('/v1/auth/password-reset/request-pin', { email });
}

export function passwordResetVerifyPin(payload: {
  email: string;
  code: string;
}): Promise<propsResponseVerifyPin> {
  return api.post('/v1/auth/password-reset/verify-pin', payload);
}

export function passwordResetConfirm(payload: {
  resetToken: string;
  newPassword: string;
}) {
  return api.post('/v1/auth/password-reset/confirm', payload);
}
